import React from 'react';
import "./TodoList.css";

const TodoList = ({ todos, deleteTodo, toggleComplete }) => {
    console.log(todos, "joshna")
  return (
    <div className="todo-list-container">
      <h2>Todo List</h2>
      <ul>
        {todos.map((todo) => (
          <li key={todo.id}>
            <div className="todo-item-content">
              <h3>{todo.title}</h3>
              <p>{todo.description}</p>
              <label>
                Completed
                <input
                  type="checkbox"
                  checked={todo.completed}
                  onChange={() => toggleComplete(todo.id)}
                />
              </label>
            </div>
            <div className="todo-item-actions">
              
              <button onClick={() => deleteTodo(todo.id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TodoList;
